import httpClient from '@utils/httpClient.js';

const getProfileId = () => localStorage.getItem('unilinkProfileId');

export function updateDigitalBlockApiCall(options) {
  const { id, isDisplayPrice, layout } = options;

  return httpClient.put(`api/profiles/${getProfileId()}/email-marketing/block/digital`, {
    id,
    isDisplayPrice,
    layout,
  });
}

export function addDigitalItemApiCall(options) {
  const { blockId, image, title, url } = options;

  return httpClient.post(`api/profiles/${getProfileId()}/email-marketing/block/digital`, {
    blockId,
    image,
    title,
    url,
  });
}

export function updateDigitalItemApiCall(id, options) {
  return httpClient.put(`api/profiles/${getProfileId()}/email-marketing/block/digital/${id}`, options);
}

export function deleteDigitalItemApiCall(id) {
  return httpClient.delete(`api/profiles/${getProfileId()}/email-marketing/block/digital/${id}`);
}
